export default __webpack_public_path__ + "b9d1ef6.png";